module.exports = __webpack_public_path__ + "static/img/bgNum.2e157e47.png";